import { loadPageBody } from '$lib/pages/body';
import type { PageLoad } from './$types';

/**
 * Resolves the homepage's body component.
 *
 * In the universal load rather than in `+page.svelte`, for two reasons that
 * pull the same way. A Svelte component cannot be serialised through a server
 * load, so it has to be resolved on this side of the boundary — the same
 * constraint that puts strain bodies in `cannabis-seeds/[slug]/+page.ts` and
 * markdown bodies in `[...path]/+page.ts`. And resolving it here means the
 * lookup can be a dynamic import: the component arrives as its own chunk,
 * instead of all thirty-five registry pages riding in the layout's.
 */
export const load: PageLoad = async ({ data }) => {
	const body =
		data.route.kind === 'page'
			? await loadPageBody(data.route.page.key, data.route.page.locale)
			: undefined;

	return { ...data, body };
};
